var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_47573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#FEF2CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 35C19.45 35 18.9792 34.8042 18.5875 34.4125C18.1958 34.0208 18 33.55 18 33V15C18 14.45 18.1958 13.9792 18.5875 13.5875C18.9792 13.1958 19.45 13 20 13H30C30.55 13 31.0208 13.1958 31.4125 13.5875C31.8042 13.9792 32 14.45 32 15V33C32 33.55 31.8042 34.0208 31.4125 34.4125C31.0208 34.8042 30.55 35 30 35H20ZM25 26C25.9 26 26.7708 26.1042 27.6125 26.3125C28.4542 26.5208 29.25 26.8167 30 27.2V18H20V27.2C20.75 26.8167 21.5458 26.5208 22.3875 26.3125C23.2292 26.1042 24.1 26 25 26ZM25 25C24.1667 25 23.4583 24.7083 22.875 24.125C22.2917 23.5417 22 22.8333 22 22C22 21.1667 22.2917 20.4583 22.875 19.875C23.4583 19.2917 24.1667 19 25 19C25.8333 19 26.5417 19.2917 27.125 19.875C27.7083 20.4583 28 21.1667 28 22C28 22.8333 27.7083 23.5417 27.125 24.125C26.5417 24.7083 25.8333 25 25 25Z",
    fill: "#F6B804"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_47573",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_47573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_47573",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHealthIcon);
export default __webpack_public_path__ + "static/media/mobile-health-icon.d6546a57656f979ff3e241a2ffcfaa85.svg";
export { ForwardRef as ReactComponent };